// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'information-solid';

export const Component = () => (
  <path
    fillRule='evenodd'
    d='M4.37 20.63C2.122 18.386 1 15.69 1 12.5c0-3.19 1.123-5.885 3.37-8.13S9.31 1 12.5 1c3.19 0 5.885 1.123 8.13 3.37C22.878 6.614 24 9.31 24 12.5c0 3.19-1.123 5.885-3.37 8.13C18.386 22.878 15.69 24 12.5 24c-3.19 0-5.885-1.123-8.13-3.37zM12.5 6c.655 0 1.25.536 1.25 1.25S13.214 8.5 12.5 8.5c-.655 0-1.25-.536-1.25-1.25S11.786 6 12.5 6zm0 4.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1z'
  />
);

export const viewBox = '0 0 25 25';
